import React from 'react'
import PropTypes from 'prop-types'
import LinkWithStatus from './LinkWithStatus'
import { Flex } from 'antd'
import { useIntl } from 'react-intl'

const ItemLink = (props) => {
  const { requestUri, name, description, infoLines } = props
  const intl = useIntl()

  return (
    <Flex gap={16} align='start' justify='space-between' className='connector full-width'>
      <div className='connector'>
          <div className='name bolder'>{name}</div>
          <div className='description'>{description}</div>
          {infoLines.map((iline) => (
            <div key={iline} style={{
              wordBreak: 'break-all',
              fontSize: '0.75rem'
            }}>HS: {iline}</div>
          ))}
      </div>

      <LinkWithStatus 
        type='link' 
        href={requestUri} 
        className='link-button'
      >
        {intl.formatMessage({id: 'forms.select'})}
      </LinkWithStatus>
    </Flex>
  )
}

ItemLink.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  requestUri: PropTypes.string.isRequired,
  infoLines: PropTypes.array,
}

export default ItemLink
